import { useSelector } from 'react-redux'
import props from '../../../../../../redux/props'
import { crud } from '@think-internet/zeus-frontend-package'
import { useState } from 'react'
import useToast, { Type } from '../../../../../hooks/useToast'
import { Concept } from '../../../../../../types/Survey/Analysis/Concept'
import { BueroType } from '../../../../../../types/Survey/Analysis/Calculation'
import Modal from '../../../../../UI/Modal/Modal'
import Input from '../../../../../UI/Input/Input'
import Dropdown from '../../../../../UI/Dropdown/Dropdown'
import Button from '../../../../../UI/Button/Button'
import useGetValuesByUnit from './useGetValuesByUnit'
import useConceptConfiguration from '../../ConceptCalculation/useConceptConfiguration'
import { PrebuildType } from '../../../../../../types/Survey/Element'
import { getUebergeordneteBedarfe } from '../../../../../hooks/useAnalysisCalculation/byBueroType/helper/getAnswerValues'

const Create: React.FC<{}> = () => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const conceptFeature = crud.use(props.SURVEY_ANALYSIS_CONCEPT)
  const [open, setOpen] = useState(false)
  const [openBasis, setOpenBasis] = useState(false)
  const [newConceptName, setNewConceptName] = useState<string>('')
  const [selectedBueroType, setSelectedBueroType] = useState<BueroType>(null)
  const { context, concepts, addConcept, conceptDataCluster } = useConceptConfiguration()
  const getValuesByUnit = useGetValuesByUnit(context)
  const toast = useToast()

  const toggle = () => setOpen(!open)
  const toggleBasis = () => setOpenBasis(!openBasis)

  const createConcept = async (index: number, name: string, bueroType: BueroType): Promise<Concept | false> => {
    const valuesByUnit = await getValuesByUnit(bueroType)
    if (!valuesByUnit) return false
    const uebergeordneteBedarfe = getUebergeordneteBedarfe(conceptDataCluster.leaderSurvey, conceptDataCluster.leaderAnswer)
    const payload: Concept = {
      surveyContextUUID: context.uuid,
      name,
      units: valuesByUnit,
      index,
      optimization: {
        verkehrsflaechenPercentage: 20,
        [PrebuildType.UEBERGEORDNETE_BEDARFE]: uebergeordneteBedarfe,
      },
    }
    const concept: Concept = await conceptFeature.create(payload)
    return concept
  }

  const saveValues = async () => {
    const customConcept = await createConcept(concepts.length, newConceptName, selectedBueroType)
    if (!!customConcept) {
      addConcept(customConcept)
      setSelectedBueroType(null)
      setNewConceptName('')
      toggle()
      toast(t.survey.analysis.concept.create.success, Type.SUCCESS)
    } else {
      toast(t.survey.analysis.concept.create.error)
    }
  }

  const createBasis = async () => {
    const baseConcepts = [BueroType.ZELLSTRUKTUR, BueroType.OPEN_SPACE, BueroType.KOMFORT, BueroType.FLEX, BueroType.AGIL]
    const basisConcepts = []
    for (let i = 0; i < baseConcepts.length; i++) {
      const type = baseConcepts[i]
      const concept = await createConcept(i, t.survey.bueroType.types[type], BueroType[type])
      if (concept) {
        basisConcepts.push(concept)
      }
    }
    addConcept(basisConcepts)
    toggleBasis()
  }

  return (
    <div className="flex flex-col gap-3 justify-between">
      <Button onClick={toggle} className="p-3 flex items-center justify-center cursor-pointer w-full" text={t.survey.analysis.concept.create.cta} />
      <Button
        onClick={toggleBasis}
        className="p-3 flex items-center justify-center cursor-pointer w-full"
        text={t.survey.analysis.concept.create.basis.cta}
      />
      <Modal show={open} onConfirm={saveValues} onClose={toggle} title={t.survey.analysis.concept.create.modalTitle}>
        <div className="text-sm text-gray">{t.survey.analysis.concept.create.hintEmptyUnits}</div>
        <Input required label={t.survey.analysis.concept.create.name} value={newConceptName} onChange={setNewConceptName} />
        <Dropdown
          className="mt-3"
          label={t.survey.analysis.concept.create.selectBueroType}
          value={selectedBueroType}
          items={Object.keys(BueroType).map((key) => ({ value: key, label: t.survey.bueroType.types[key] }))}
          onChange={setSelectedBueroType}
          required
        />
      </Modal>
      <Modal show={openBasis} onConfirm={createBasis} onClose={toggleBasis} title={t.survey.analysis.concept.create.basis.modalTitle}>
        <div className="text-sm text-gray">{t.survey.analysis.concept.create.hintEmptyUnits}</div>
        <div className="text-sm text-gray mt-2">{t.survey.analysis.concept.create.basis.noOverwriteHint}</div>
      </Modal>
    </div>
  )
}

export default Create
